/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../../../components/Modal';
import { LoyaltyProgramScreensFlow } from '../../constants';
import SelectCashbackCurrency from './SelectCashbackCurrency';

const LoyaltyProgramModal = ({ hide, allowedCurrencies, checkedWallets, setCashbackChanged }) => {
  const [currentScreen, setCurrentScreen] = useState(LoyaltyProgramScreensFlow.SELECT_CURRENCY);

  const screens = useMemo(
    () => [
      {
        screen: LoyaltyProgramScreensFlow.SELECT_CURRENCY,
        component: (
          <SelectCashbackCurrency
            allowedCurrencies={allowedCurrencies}
            checkedWallets={checkedWallets}
            onCloseModal={hide}
            openScreen={setCurrentScreen}
            setIsCashbackChanged={setCashbackChanged}
          />
        ),
      },
    ],
    []
  );

  const SelectedComponent = useMemo(
    () => screens.find((item) => item.screen === currentScreen).component,
    [screens, currentScreen]
  );

  return (
    <ModalRoot>
      <Modal>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{SelectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};

LoyaltyProgramModal.propTypes = {
  hide: PropTypes.func,
  setCashbackChanged: PropTypes.func,
  allowedCurrencies: PropTypes.object.isRequired,
  checkedWallets: PropTypes.arrayOf(PropTypes.string).isRequired,
};
LoyaltyProgramModal.defaultProps = {
  hide: null,
  setCashbackChanged: null,
};

export default LoyaltyProgramModal;
